import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { login } from "../../actions/authActions";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import Form from "./Form";
import { Typography } from "@material-ui/core";
import moment from "moment";

class LoginForm extends Component {
  state = {
    email: "",
    password: "",
  };

  login = (e) => {
    e.preventDefault();

    this.props.login(this.state).then((response) => {
      let tokenExpirationDate = moment().add(2, "hours");

      localStorage.setItem("tokenExpirationDate", tokenExpirationDate);

      localStorage.setItem("credentials", JSON.stringify(response));

      document.location.href = this.props.urlRedirect
        ? this.props.urlRedirect
        : "/";
    });
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    return (
      <Fragment>
        <Form
          onSubmit={this.login}
          submitText="Log in"
          isFetching={this.props.isFetching}
          successMessage={this.props.successMessage}
          errorMessage={this.props.errorMessage}
        >
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="email">Emailadres</InputLabel>
            <Input
              id="email"
              name="email"
              autoComplete="email"
              value={this.state.email}
              onChange={this.handleChange}
              autoFocus
            />
          </FormControl>
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="password">Wachtwoord</InputLabel>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={this.state.password}
              onChange={this.handleChange}
            />
          </FormControl>
        </Form>
        <br />
        <Typography variant="body1" align="center">
          <a href="/forgot-password">Wachtwoord vergeten</a>
        </Typography>
      </Fragment>
    );
  }
}

LoginForm.propTypes = {
  login: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
  urlRedirect: PropTypes.string,
};

const mapStateToProps = (state) => ({
  successMessage: state.auth.login.successMessage,
  errorMessage: state.auth.login.errorMessage,
  isFetching: state.auth.login.isFetching,
});

export default connect(mapStateToProps, { login })(LoginForm);



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm.js